module.exports = __webpack_public_path__ + "img/maintenance-1.22898cc6.png";